/* global UC_UI */

import React from 'react';
import { EonUiSection, EonUiLink } from '@eon-ui/eon-ui-components-react';

const footerData = [{
  text: 'Presse-Kontakt',
  href: 'https://www.eon.de/de/unternehmen/presse/presse-kontakt.html'
}, {
  text: 'Media Center',
  href: 'https://www.eon.de/de/unternehmen/presse/media-center.html'
}, {
  text: 'Impressum',
  href: 'https://www.eon.de/de/pk/impressum.html'
}, {
  text: 'Datenschutz',
  href: 'https://www.eon.de/de/pk/datenschutz.html'
}, {
  text: 'Disclaimer',
  href: 'https://www.eon.de/de/pk/disclaimer.html'
}];

const Footer = () => (
  <footer className='eaFooter' style={{ borderTop: '2px solid #e7e7e8' }}>
    <EonUiSection remove-top-spacing remove-bottom-spacing>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px 24px',
        padding: '8px 0',
        flexWrap: 'wrap'
      }}>
        {footerData.map((item) => (
          <EonUiLink
            size='small'
            target='_blank'
            hide-icon
            text={item.text}
            href={item.href}
            key={item.text}
          />
        ))}

        <EonUiLink
          size='small'
          text='Cookies'
          hide-icon
          onClick={() => {
            if (typeof UC_UI !== 'undefined') {
              UC_UI.showSecondLayer();
            }
          }}
        />
      </div>
    </EonUiSection>
  </footer>
);

export default React.memo(Footer);